import { satsToBtc } from '@/utils/bitcoin'

interface VaultProgressProps {
  confirmedBalanceSats: number | null
  goalBtc: number | null
  onDonate?: () => void
}

export default function VaultProgress({ confirmedBalanceSats, goalBtc, onDonate }: VaultProgressProps) {
  const loaded = confirmedBalanceSats !== null
  const balanceBtc = loaded ? parseFloat(satsToBtc(confirmedBalanceSats)) : 0
  const percentage = loaded && goalBtc ? Math.min((balanceBtc / goalBtc) * 100, 100) : 0

  return (
    <div className="bg-gray-800 rounded-xl p-6">
      <div className="flex items-start justify-between gap-3 mb-4">
        <h3 className="text-lg font-semibold text-white">Vault Balance</h3>
        {onDonate && (
          <button
            onClick={onDonate}
            className="bg-bitcoin hover:bg-bitcoin-dark text-white font-semibold py-1.5 px-4 rounded-lg transition-colors"
          >
            Donate
          </button>
        )}
      </div>

      <div className="text-3xl font-bold text-bitcoin mb-1">
        {loaded ? satsToBtc(confirmedBalanceSats) : '—'}
      </div>
      <div className="text-gray-400 text-sm mb-4">BTC</div>

      {goalBtc && (
        <>
          <div className="w-full bg-gray-700 rounded-full h-3 mb-2">
            <div
              className="bg-bitcoin rounded-full h-3 transition-all duration-500"
              style={{ width: `${percentage}%` }}
            />
          </div>
          <div className="text-gray-400 text-sm">
            {loaded ? `${percentage.toFixed(1)}% of ${goalBtc} BTC goal` : '—'}
          </div>
        </>
      )}
    </div>
  )
}
